import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import { FaBookOpen, FaBookOpenReader } from "react-icons/fa6";
import BrowseTrainings from "./index";
// import ViewTrainingOverview from "./view";
// import EditTrainingOverview from "./edit";
import { MODULE_TRAINING } from "variables/constants";

const browseTrainingRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Browse Training",
		basePath: "browse-trainings",
		mainComponent: <BrowseTrainings />,
	    layout: "/console",	   
	    icon: <FaBookOpenReader className="icon-item" />,
	    subTitle:"Browse Trainings",
	    // viewComponent: <ViewTrainingOverview />,
	    // createComponent: <EditTrainingOverview />,
	    // editComponent: <EditTrainingOverview />,
		level:5,
		moduleId: 0,
	})
]

export default browseTrainingRoutes;